@if (currentMessage) {
  <div class="hint-container" @hintAnimation (@hintAnimation.done)="onAnimationDone($event)">
    <div class="hint-content" [ngStyle]="hintStyles | theme">
      @for (segment of currentMessage.segments; track $index) {
        <span [ngClass]="getSegmentClass(segment)">
          @if (segment.type === "currency") {
            <span>
              @if (segment.icon && segment.iconPosition === "start") {
                <app-currency-icon [icon]="segment.icon" sizeCss="--icon-medium" />
              }
              {{ segment.content }}
              @if (segment.icon && segment.iconPosition === "end") {
                <app-currency-icon [icon]="segment.icon" sizeCss="--icon-medium" />
              }
            </span>
          }
          @if (segment.type !== "currency") {
            <span>{{ segment.content }}</span>
          }
        </span>
      }
    </div>
  </div>
}
